import React from 'react'
import ReactDOM from 'react-dom/client'
import './themes.css'
import './layout.css'
import './index.css'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
    <App />
  </div>
)